import React from 'react';
import ReactDOM from 'react-dom';
import CurrentDay from './currentDay.js';
import NextDays from './nextDays.js'
import './index.css';

class App extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            data: null,
            lon: null,
            lat: null,
            city: null,
        }
    }

    success = (position) => {
        this.setState({lon: position.coords.longitude, lat: position.coords.latitude})
        const weatherKey = 'a913b85241698a00b1014abe62a5ca0e';
        // const locationKey = '74b2d16131a57f25ad6a62156047b305';
        fetch(`https://api.openweathermap.org/data/2.5/onecall?lat=${this.state.lat}&lon=${this.state.lon}&exclude=hourly,minutely&appid=${weatherKey}&units=metric`)
        .then((response) => {return response.json()})
        .then((data) => {
            this.setState({data: data})
        })

        fetch(`https://api.openweathermap.org/geo/1.0/reverse?lat=${this.state.lat}&lon=${this.state.lon}&limit=1&appid=${weatherKey}`)
        .then((response) => {return response.json()})
        .then((data) => {
            this.setState({city: data[0].name})
        })
    }

    fail = (error) => {
        this.setState({lon: 26.251617, lat: 50.619900})
        const weatherKey = 'a913b85241698a00b1014abe62a5ca0e';
        fetch(`https://api.openweathermap.org/data/2.5/onecall?lat=${this.state.lat}&lon=${this.state.lon}&exclude=hourly,minutely&appid=${weatherKey}&units=metric`)
        .then((response) => {return response.json()})
        .then((data) => {
            this.setState({data: data})
        })

        fetch(`https://api.openweathermap.org/geo/1.0/reverse?lat=${this.state.lat}&lon=${this.state.lon}&limit=1&appid=${weatherKey}`)
        .then((response) => {return response.json()})
        .then((data) => {
            this.setState({city: data[0].name})
        })
            alert('Currently we can not get your geolocation due to: ' + error.message)
    }

    async findCity (event) {
        event.preventDefault();
        const weatherKey = 'a913b85241698a00b1014abe62a5ca0e';
        // const locationKey = '74b2d16131a57f25ad6a62156047b305';
        const city = document.getElementById('search').value;
        document.getElementById('search').value = '';

        await fetch(`https://api.openweathermap.org/geo/1.0/direct?q=${city}&limit=1&appid=${weatherKey}`)
        .then((response) => {return response.json()})
        .then((data) => {
           try {
            this.setState({lon: data[0].lon, lat: data[0].lat, city: city});
           } catch (error) {
               this.setState({city:'not found'});
               return;
           }
        })

        await fetch(`https://api.openweathermap.org/data/2.5/onecall?lat=${this.state.lat}&lon=${this.state.lon}&exclude=hourly,minutely&appid=${weatherKey}&units=metric`)
        .then((response) => {return response.json()})
        .then((data) => {
            this.setState({data: data})
        })
    }

    componentDidMount() {
        const geo = navigator.geolocation;
        
        if(!geo) {
            this.fail()
        } else {
            geo.getCurrentPosition(this.success, this.fail)
        }
    }

    componentWillUnmount() {
    }

    render() {
        if (this.state.data == null) {
            return (
                <div className="loading">
                    <span>Loading data, please wait</span>
                </div>
            )
        } else {}
        return (
            <div className="app">
                <form className="find">
                    <input id="search" type="text" placeholder="Enter location name" pattern="[A-Za-z]"></input>
                    <button type="submit" onClick={this.findCity.bind(this)}>Search</button>
                </form>
                <CurrentDay weather={this.state.data.current} city={this.state.city}/>
                <div className="future">
                    <NextDays weather={this.state.data.daily} city={this.state.city} id={1}/>
                    <NextDays weather={this.state.data.daily} city={this.state.city} id={2}/>
                    <NextDays weather={this.state.data.daily} city={this.state.city} id={3}/>
                    <NextDays weather={this.state.data.daily} city={this.state.city} id={4}/>
                    <NextDays weather={this.state.data.daily} city={this.state.city} id={5}/>
                    <NextDays weather={this.state.data.daily} city={this.state.city} id={6}/>
                    <NextDays weather={this.state.data.daily} city={this.state.city} id={7}/>
                </div>
            </div>
        );
    }
}


//================================================================
ReactDOM.render(
    <App />,
    document.getElementById('root')
)